import { render, staticRenderFns } from "./Heizung.vue?vue&type=template&id=2b30462f"
import script from "./Heizung.vue?vue&type=script&lang=js"
export * from "./Heizung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports